import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CheckoutPixPageComponent } from './checkout-pix-page/checkout-pix-page.component';
import { MaterialAngularModule } from '../material-design/material.module';
import { BrowserModule } from '@angular/platform-browser';
import { ComponentsModule } from '../shared/components/components.module';
import { CheckoutBoletoPageComponent } from './checkout-boleto-page/checkout-boleto-page.component';
import { CheckoutPixRenegociacaoPageComponent } from './checkout-pix-renegociacao-page/checkout-pix-renegociacao-page.component';
import { CheckoutBoletoRenegociacaoComponent } from './checkout-boleto-renegociacao/checkout-boleto-renegociacao.component';



@NgModule({
  declarations: [
    CheckoutPixPageComponent,
    CheckoutBoletoPageComponent,
    CheckoutPixRenegociacaoPageComponent,
    CheckoutBoletoRenegociacaoComponent
  ],
  imports: [
    CommonModule,
    ComponentsModule,
    BrowserModule,
    MaterialAngularModule,
  ]
})
export class CheckoutModule { }
